import { render, staticRenderFns } from "./ProfessionalsSelector.vue?vue&type=template&id=04da6cf8"
import script from "./ProfessionalsSelector.vue?vue&type=script&lang=js"
export * from "./ProfessionalsSelector.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalsSelector.vue?vue&type=style&index=0&id=04da6cf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports